import { ApiService } from "@/api";

export const getFeedbackList = () => {
  return ApiService.baseAction("feedback/list", {}, "get");
};
